import * as moment from 'moment';

import { StudyTranslation } from './study-translation';

export interface ModuleItemAttribute {
  label?: string;
  name?: string;
  type?: string;
  id?: number;
  attribute?: string;
  errorMsg?: string;
  moduleItemId?: number;
  value?: string;
  createdAt?: moment.Moment;
  updatedAt?: moment.Moment;
  translations?: StudyTranslation[];
}

// TODO: Add missing attributes for other module items
export enum ModuleItemAvailableAttribute {
  BUTTON_LABEL = 'button_label',
  MAX_CHARACTERS = 'max_characters',
  CHOICES = 'choices',
  RANDOMIZE = 'randomize',
  YES_LABEL = 'label_yes',
  NO_LABEL = 'label_no',
  MIN_VALUE = 'min_value',
  MAX_VALUE = 'max_value',
  STEP_SIZE = 'step_size',
  ALLOW_OTHER = 'allow_other',
  MIN_ANSWERS = 'min_answers',
  MAX_ANSWERS = 'max_answers',
  X_AXIS = 'x_axis',
  Y_AXIS = 'y_axis',
  QUADRANT_IMAGE = 'quadrant_image',
  SLIDER_LABEL = 'slider_label',
  LABEL_LEFT = 'label_left',
  LABEL_RIGHT = 'label_right',
  ORBITS = 'orbits',
  HIDE_INFO = 'hide_info',
  CORRECT_ZONE = 'correct_zone',
  TOP_ZONE_GROUP = 'top_zone_group',
  TOP_ZONE_WORD = 'top_zone_word',
  TOP_ZONE_COLOR = 'top_zone_color',
  TOP_ZONE_AUDIO = 'top_zone_audio',
  BOTTOM_ZONE_GROUP = 'bottom_zone_group',
  BOTTOM_ZONE_WORD = 'bottom_zone_word',
  BOTTOM_ZONE_COLOR = 'bottom_zone_color',
  BOTTOM_ZONE_AUDIO = 'bottom_zone_audio',
  DRAG_WORD = 'drag_word',
  DRAG_WORD_COLOR = 'drag_word_color',
}
